import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    container: {
        overflow: 'hidden',
    }
}));

export default useStyles;
